module.exports = __webpack_public_path__ + "media/images/flags/16/Belgium-cfef7f004c9d2e1da4d7a25630c9a06f.png";